<template>
  <slot></slot>
</template>

<script>
import { Fancybox as NativeFancybox } from "@fancyapps/ui/dist/fancybox.esm.js";

export default {
  props: {
    options: {
      type: Object,
      required: false,
      default: null,
    },
  },
  emits: ["init", "initLayout", "initCarousel", "ready", "load", "reveal", "done", "keydown", "shouldClose", "closing", "destroy"],
  mounted() {
    NativeFancybox.bind("[data-fancybox]", {
      dragToClose: false,
      closeButton: "outside",
      template: {
        closeButton: `<i class="icon-close"></i>`,
        main: `
            <div class="fancybox__container" role="dialog" aria-modal="true" aria-hidden="true" aria-label="{{MODAL}}" tabindex="-1">
                <div class="fancybox__backdrop"></div>
                <div class="fancybox__carousel"></div>
            </div>
        `,
      },
      Image: {
        zoom: false,
      },
      Carousel: {
        slidesPerPage: 1,
        Navigation: {
          prevTpl: `<i class="icon-arrow-slim-left">`,
          nextTpl: `<i class="icon-arrow-slim-right">`,
        },
      },
      Thumbs: {
        autoStart: true,
      },
      Toolbar: {
        display: [],
      },
      on: {
        init: (fancybox, slide) => {
          this.$emit("init");
        },
        initLayout: (fancybox, slide) => {
          this.$emit("initLayout");
        },
        initCarousel: (fancybox, slide) => {
          this.$emit("initCarousel");
        },
        ready: (fancybox, slide) => {
          this.$emit("ready");
        },
        load: (fancybox, slide) => {
          this.$emit("load");
        },
        reveal: (fancybox, slide) => {
          this.$emit("reveal");
        },
        done: (fancybox, slide) => {
          this.$emit("done");
        },
        keydown: (fancybox, slide) => {
          this.$emit("keydown");
        },
        shouldClose: (fancybox, slide) => {
          this.$emit("shouldClose");
        },
        closing: (fancybox, slide) => {
          this.$emit("closing");
        },
        destroy: (fancybox, slide) => {
          this.$emit("destroy");
        },
      },
    });
  },
};
</script>

<style>
</style>